import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import nomorOKService from "../../../services/ref/nomorOKService";
import Cookies from "js-cookie";

export const initialState = {
    loading_nomor_ok: false,
    data_nomor_ok: [],
    showMessage:false,
    message:'',
}


export const getDataNomorOK = createAsyncThunk('nomor_ok/data',async (data, { rejectWithValue }) => {
    try {
        const response = await nomorOKService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const nomorOKSlice = createSlice({
    name: 'nomor_ok',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_nomor_ok = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataNomorOK.fulfilled, (state, action) => {
                state.loading_nomor_ok = false
                state.data_nomor_ok = action.payload??[]
            })
            .addCase(getDataNomorOK.pending, (state) => {
                state.loading_nomor_ok = true
            })
            .addCase(getDataNomorOK.rejected, (state, action) => {
                state.loading_nomor_ok = false
                state.data_nomor_ok = action.payload
            })
    },
})

export const {
    showLoading,
} = nomorOKSlice.actions

export default nomorOKSlice.reducer
